import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _parseFloat from "@babel/runtime-corejs3/core-js/parse-float";
import _endsWithInstanceProperty from "@babel/runtime-corejs3/core-js/instance/ends-with";
import moment from "moment";
import * as RemindersFilters from "./reminders-filters";
import * as dateHelpers from "../../helpers/dates";
import * as utilHelpers from "../../helpers/helpers";
import * as textHelpers from "../../helpers/text";
import * as applicationHelpers from "../../helpers/application";
import * as settingsHelpers from "../../helpers/settings";
import * as moneyHelpers from "../../helpers/money";
import { emailProviderImage } from "@Shared/utils/helpers/email-integration";
import { countComments, humanFileSize } from "@Shared/utils/helpers/documents";
import { stringToHash } from "@Shared/utils/utils";
import { getLogo } from "@Shared/@Utils/helpers/theme";
import { lowerCase, startCase, toLower } from "lodash";
export default Vue => {
  //TODO move from helpers to this folder
  _filterInstanceProperty(Vue).call(Vue, "formatDatepickerDate", dateHelpers.formatDatepickerDate);
  _filterInstanceProperty(Vue).call(Vue, "nameFormat", textHelpers.nameFormat);
  _filterInstanceProperty(Vue).call(Vue, "formatMoneyValue", moneyHelpers.formatMoneyValue);
  _filterInstanceProperty(Vue).call(Vue, "formatTimeAgo", dateHelpers.formatTimeAgo);
  _filterInstanceProperty(Vue).call(Vue, "basicFormatTimeFromTime", dateHelpers.basicFormatTimeFromTime);
  _filterInstanceProperty(Vue).call(Vue, "formatDateHour", dateHelpers.formatDateHour);
  _filterInstanceProperty(Vue).call(Vue, "formatDateTimezone", dateHelpers.formatDateTimezone);
  _filterInstanceProperty(Vue).call(Vue, "momentFormat", dateHelpers.momentFormat);
  _filterInstanceProperty(Vue).call(Vue, "getApplicationFlow", applicationHelpers.getApplicationFlow);
  _filterInstanceProperty(Vue).call(Vue, "parsePercentageDecimal", utilHelpers.parsePercentageDecimal);
  _filterInstanceProperty(Vue).call(Vue, "parsePercentage", utilHelpers.parsePercentage);
  _filterInstanceProperty(Vue).call(Vue, "formatMoneyValueLong", moneyHelpers.formatMoneyValueLong);
  _filterInstanceProperty(Vue).call(Vue, "formatIntegerQuantity", moneyHelpers.formatIntegerQuantity);
  _filterInstanceProperty(Vue).call(Vue, "formatNumeral", utilHelpers.formatNumeral);
  _filterInstanceProperty(Vue).call(Vue, "moment", (date, format) => {
    return moment(date).format(format);
  });
  _filterInstanceProperty(Vue).call(Vue, "capitalize", textHelpers.capitalize);
  _filterInstanceProperty(Vue).call(Vue, "uppercase", textHelpers.uppercase);
  _filterInstanceProperty(Vue).call(Vue, "kebabToSentence", textHelpers.kebabToSentence);
  _filterInstanceProperty(Vue).call(Vue, "formatDate", dateHelpers.formatDate);
  _filterInstanceProperty(Vue).call(Vue, "formatUnixDate", dateHelpers.formatUnixDate);
  _filterInstanceProperty(Vue).call(Vue, "activityClass", utilHelpers.activityClass);
  _filterInstanceProperty(Vue).call(Vue, "portalDomain", utilHelpers.portalDomain);
  _filterInstanceProperty(Vue).call(Vue, "followupClassification", utilHelpers.followupClassification);
  _filterInstanceProperty(Vue).call(Vue, "basicPluralize", textHelpers.basicPluralize);
  _filterInstanceProperty(Vue).call(Vue, "avatarPlaceholder", utilHelpers.avatarPlaceholder);
  _filterInstanceProperty(Vue).call(Vue, "dateContextColor", dateHelpers.dateContextColor);
  _filterInstanceProperty(Vue).call(Vue, "parseReminderClassificationClass", RemindersFilters.parseReminderClassificationClass);
  _filterInstanceProperty(Vue).call(Vue, "parseReminderClassificationTimeAgo", RemindersFilters.parseReminderClassificationTimeAgo);
  _filterInstanceProperty(Vue).call(Vue, "reminderClassificationStatusMap", RemindersFilters.reminderClassificationStatusMap);
  _filterInstanceProperty(Vue).call(Vue, "mainSiteDomain", settingsHelpers.mainSiteDomain);
  _filterInstanceProperty(Vue).call(Vue, "applicationStatus", textHelpers.textStatusShort);
  _filterInstanceProperty(Vue).call(Vue, "removeHyphens", textHelpers.removeHyphens);
  _filterInstanceProperty(Vue).call(Vue, "toUppercase", text => startCase(text));
  _filterInstanceProperty(Vue).call(Vue, "truncateText", textHelpers.truncateText);
  _filterInstanceProperty(Vue).call(Vue, "truncateFileName", textHelpers.truncateFileName);
  _filterInstanceProperty(Vue).call(Vue, "formatDateLocalCustom", dateHelpers.formatDateLocalCustom);
  _filterInstanceProperty(Vue).call(Vue, "fullName", textHelpers.fullName);
  _filterInstanceProperty(Vue).call(Vue, "formatRate", value => _parseFloat(value).toFixed(2));
  _filterInstanceProperty(Vue).call(Vue, "formatToSentence", value => startCase(toLower(value)));
  _filterInstanceProperty(Vue).call(Vue, "camelToSentence", value => startCase(lowerCase(value)));
  _filterInstanceProperty(Vue).call(Vue, "setNAValue", utilHelpers.setNAValue);
  _filterInstanceProperty(Vue).call(Vue, "momentLocal", dateHelpers.momentLocal);
  _filterInstanceProperty(Vue).call(Vue, "formatUTC", dateHelpers.formatUTC);
  _filterInstanceProperty(Vue).call(Vue, "formatDateUTCCustom", dateHelpers.formatDateUTCCustom);
  _filterInstanceProperty(Vue).call(Vue, "upperCaseFirst", textHelpers.upperCaseFirst);
  _filterInstanceProperty(Vue).call(Vue, "splitMessage", textHelpers.splitMessage);
  _filterInstanceProperty(Vue).call(Vue, "isCurrentUser", utilHelpers.isCurrentUser);
  _filterInstanceProperty(Vue).call(Vue, "thousandsFormatNumber", value => new Intl.NumberFormat().format(value));
  _filterInstanceProperty(Vue).call(Vue, "emailProviderImage", emailProviderImage);
  _filterInstanceProperty(Vue).call(Vue, "countComments", countComments);
  _filterInstanceProperty(Vue).call(Vue, "toUploadHour", dateHelpers.toUploadHour);
  _filterInstanceProperty(Vue).call(Vue, "formatHyphens", textHelpers.formatHyphens);
  _filterInstanceProperty(Vue).call(Vue, "pluralizeWord", textHelpers.pluralizeWord);
  _filterInstanceProperty(Vue).call(Vue, "booleanYesNo", textHelpers.booleanYesNo);
  _filterInstanceProperty(Vue).call(Vue, "humanFileSize", humanFileSize);
  _filterInstanceProperty(Vue).call(Vue, "formatDateExpiration", dateHelpers.formatDateExpiration);
  _filterInstanceProperty(Vue).call(Vue, "applicationStatusLabel", applicationHelpers.getApplicationStatusLabel);
  _filterInstanceProperty(Vue).call(Vue, "finishWithDot", text => _endsWithInstanceProperty(text).call(text, ".") ? text : `${text}.`);
  _filterInstanceProperty(Vue).call(Vue, "hashId", text => {
    return text && `id-${stringToHash(text)}` || "";
  });
  _filterInstanceProperty(Vue).call(Vue, "getSchemaTranslation", (key, translationMap) => {
    if (!translationMap) return key;
    return (translationMap == null ? void 0 : translationMap[key]) || key;
  });
  _filterInstanceProperty(Vue).call(Vue, "getLogo", getLogo);
  _filterInstanceProperty(Vue).call(Vue, "getApplicantName", applicationHelpers.getApplicantName);
};